module.exports = __webpack_public_path__ + "static/media/news1.6e7356ef.jpg";